<template>
  <Tile
    class="credit-card"
    :class="{ [`credit-card--${size}`]: size }"
    :focusable="focusable"
    :selected="selected"
    :disabled="card.is_purged"
    @click="$emit('click', $event)"
  >
    <div class="credit-card-info">
      <img
        v-if="cardImage && $slots.button"
        class="credit-card-icon credit-card-icon--left"
        :src="cardImage"
        alt=""
      />
      <div class="credit-card-description">
        <div class="credit-card-label">{{ cardName }}</div>
        <div class="credit-card-number">
          {{ cardNumber }}
        </div>
      </div>
    </div>
    <slot name="button"></slot>
    <img
      v-if="cardImage && !$slots.button"
      class="credit-card-icon credit-card-icon--right"
      :src="cardImage"
      alt=""
    />
  </Tile>
</template>

<script>
import Tile from "@/shared_components/Tile";
import getCreditCardType from "@/helpers/getCreditCardType";
import cardTypes from "@/constants/cardTypes";
import creditCardIcons from "@/constants/creditCardIcons";
import { maskCreditCardNumber } from "@/helpers/creditCardNumber";

export default {
  components: {
    Tile
  },
  props: {
    card: {
      type: Object,
      required: true
    },
    focusable: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    cardTypeDescription() {
      switch (this.card.type) {
        case cardTypes.PERSONAL:
          return "Personal";
        case cardTypes.CORPORATE:
          return "Corporate";
        case cardTypes.PERSONAL_AND_CORPORATE:
          return "Personal & Corporate";
      }
      return "";
    },
    cardName() {
      const baseString = this.card.nickname
        ? `${this.cardTypeDescription} (${this.card.nickname})`
        : this.cardTypeDescription;
      if (this.card.is_purged) {
        return `${baseString} - Purged`;
      }
      return baseString;
    },
    cardNumber() {
      return maskCreditCardNumber(this.card.card_length, this.card.last_four);
    },
    cardImage() {
      const type = getCreditCardType(this.card.first_six);
      return creditCardIcons[type];
    }
  }
};
</script>

<style scoped lang="scss">
@import "bulma/sass/utilities/mixins.sass";
@import "@/scss/colors.scss";

.credit-card {
  justify-content: space-between;
  padding: 10px 20px;
  @include mobile {
    padding: 5px 10px;
  }
  &-info {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
  &-description {
    display: flex;
    flex-direction: column;
  }
  &-label {
    color: rgba(#000, 0.5);
    font-size: 14px;
  }
  &-number {
    font-size: 14px;
  }
  &-icon {
    display: block;
    &--left {
      margin-right: 10px;
      width: 50px;
      @include mobile {
        width: 30px;
      }
    }
    &--right {
      width: 60px;
      @include mobile {
        width: 50px;
      }
    }
  }
  &--is-small {
    padding: 5px 10px;
    .credit-card-icon {
      &--left {
        width: 30px;
      }
      &--right {
        width: 50px;
      }
    }
  }
}
</style>
